import moment from 'moment'
import Vue from 'vue'
export default {
  securityToken: function(state) {
    return 'BEARER ' + state.userid + ' ' + state.accessToken
  },
  isLoading: function(state) {
    return state.loading
  },
  isLoggedIn: function(state) {
    return state.isLoggedIn
  },
  unsubscribedPage: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        if (!isFound) {
          pagelist.push(pageValue)
        }
      })
    }

    return pagelist
  },
  allPage: function(state) {
    let pagelist = []

    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }

    return pagelist
  },
  selectedBot: function(state) {
    if (state.selectedBot == null) {
      return null
    }
    var selectedBot = state.selectedBot
    // selectedBot.ketshop_api_key = 'aaa'
    // selectedBot.ketshop_api_secret = 'aaa'
    return selectedBot
  },
  botlist: function(state) {
    return state.botlist
  },
  isSelectedBot: function(state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function(state) {
    return state.paypalTrackingId
  },
  setting: function(state) {
    return state.setting
  },
  welcomeMessage: function(state) {
    return state.welcomeMessage
  },
  showModalWelcome: function(state) {
    return state.showModalWelcome
  },
  isFacebook: function(state) {
    return state.isFacebook
  },
  isCoachlab: function(state) {
    return state.selectedBot.pagetype == 'coachlab'
  },
  getPackage: function(state) {
    var now = moment()
    if (!state.selectedBot) {
      return 'normal'
    }
    var date = moment(state.selectedBot.expireat)
    var expriedTime = parseInt(date.diff(now, 'seconds'))
    return expriedTime > 0 ? 'premium' : 'normal'
  },
  currentLang: function(state) {
    return Vue.i18n.locale()
  },
  showAlert: state => type => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function(el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getCategories: function(state) {
    return state.ecommerce.categories
  },
  getBotPageRole: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }
    var bot = pagelist.find(function(val, index) {
      return val.id == state.selectedBot.pageid
    })
    if (bot) {
      if (bot.perms) {
        return bot.perms.indexOf('ADMINISTER') > -1
      } else if (bot.tasks) {
        return bot.tasks.indexOf('MANAGE') > -1
      }
    } else {
      return null
    }
  },
  getLoadingCategory: function(state) {
    return state.ecommerce.loadingCategory
  },
  getProducts: function(state) {
    return state.ecommerce.products
  },
  getLoadingProduct: function(state) {
    return state.ecommerce.loadingProduct
  },
  getUserStatus: function(state) {
    return state.userStatus
  },
  getLoadingUserStatus: function(state) {
    return state.loadingUserStatus
  },
  getLoadingSetting: function(state) {
    return state.loadingSetting
  },
  getSetting: function(state) {
    return state.setting
  },
  getLoadingCharges: function(state) {
    return state.ecommerce.loadingCharges
  },
  getCharges: function(state) {
    return state.ecommerce.charges
  },
  getLoadingLinePushMessageCount: function(state) {
    return state.linePushMessageCount
  },
  getLinePushMessageCount: function(state) {
    return state.loadingLinePushMessageCount
  },
  getLivechatUsers: function(state) {
    return type => {
      if (state.livechat && state.livechat.userlist[type]) {
        return state.livechat.userlist[type].users
      } else {
        return []
      }
    }
  },
  getCurrentUser: function(state) {
    return state.livechat.currentUser
  },
  allSchools: function(state) {
    return state.allSchools
  },
  getPageProfile: function(state) {
    return state.pageProfile
  },
  getLoadingPageProfile: function(state) {
    return state.loadingPageProfile
  },
  getLoadingPartnerProfile: function(state) {
    return state.loadingPartnerProfile
  },
  getPartnerProfile: function(state) {
    return state.partnerProfile
  },
  // ticketing
  getLoadingAgentGroup: function(state) {
    return state.loadingAgentGroups
  },
  getAgentGroup: function(state) {
    return state.agentGroups
  },
  getLoadingAgentSubgroup: function(state) {
    return state.loadingAgentSubgroups
  },
  getAgentSubgroup: function(state) {
    return state.agentSubgroups
  },
  getLoadingAgent: function(state) {
    return state.loadingAgents
  },
  getAgent: function(state) {
    return state.agents
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js